// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgMicOff24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M16.0001 6C16.0001 3.79086 14.2092 2 12.0001 2C9.79094 2 8.00008 3.79086 8.00008 6V6.55039L4.22149 2.7718C3.9286 2.4789 3.45373 2.4789 3.16083 2.7718C2.86794 3.06469 2.86794 3.53957 3.16083 3.83246L8.00008 8.67171V11C8.00008 13.2091 9.79094 15 12.0001 15C12.6743 15 13.3096 14.8332 13.8669 14.5385L14.7817 15.4534C13.9752 15.9582 13.0217 16.25 12.0001 16.25C9.10058 16.25 6.75008 13.8995 6.75008 11C6.75008 10.5858 6.41429 10.25 6.00008 10.25C5.58587 10.25 5.25008 10.5858 5.25008 11C5.25008 14.4745 7.87527 17.3359 11.2504 17.7088L11.2501 21.5C11.2501 21.9142 11.5859 22.25 12.0001 22.25C12.4143 22.25 12.7501 21.9142 12.7501 21.5L12.7508 17.7087C13.9002 17.5815 14.9625 17.1658 15.8639 16.5355L20.1608 20.8325C20.4537 21.1254 20.9286 21.1254 21.2215 20.8325C21.5144 20.5396 21.5144 20.0647 21.2215 19.7718L16.9926 15.5429C18.0844 14.3437 18.7501 12.7496 18.7501 11C18.7501 10.5858 18.4143 10.25 18.0001 10.25C17.5859 10.25 17.2501 10.5858 17.2501 11C17.2501 12.3353 16.7515 13.5542 15.9304 14.4807L15.0444 13.5947C15.6403 12.8962 16.0001 11.9901 16.0001 11V6ZM13.9784 12.5287C14.3054 12.1061 14.5001 11.5758 14.5001 11V6C14.5001 4.61929 13.3808 3.5 12.0001 3.5C10.6194 3.5 9.50008 4.61929 9.50008 6V8.05039L13.9784 12.5287ZM9.50008 10.1717V11C9.50008 12.3807 10.6194 13.5 12.0001 13.5C12.2512 13.5 12.4937 13.463 12.7224 13.3941L9.50008 10.1717Z"
				/>
			</Svg>
		);
	}
);
SvgMicOff24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgMicOff24;
